<template>
  <div>
    <input-info-edit></input-info-edit>
  </div>
    
  <!-- <pre>{{counselor_info.name}}</pre> -->
</template>
<script>
import {mapState, mapActions, mapGetter} from 'vuex';
import InputInfoEdit from "./components/EditProfile/InputInfoEdit.vue"
export default{
  components:{
  },
  data: function(){
    return {
      user: {},
      // counselor_info: {}
    }
  },
  components:{
    InputInfoEdit
  },
  computed: {
    ...mapState('user',{
      user_info: state => {
        return state.user_info      
      }
    }),
  },
  created:function(){
    this.$store.dispatch('user/get_user_info', this.$route.query.id)
    this.$store.dispatch('services/load_list_services')
  }
};
</script>
<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/views/EditProfile.vue